import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, Subject, Subscription, takeUntil, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public data: any;
  public menu = new BehaviorSubject({} as any);
  public logo = new BehaviorSubject({} as any);
  public isTokenSet = new BehaviorSubject(Boolean);
  
  language: string = 'en-US';

  constructor(private http: HttpClient) {
    this.GetMenuData();
    this.GetPermission();
  }

  GetMenuData() {
    if (sessionStorage.getItem('IsSetToken') == 'true') {
      this.loadMenuData();
      this.loadUserLogo();

    }
    this.isTokenSet.subscribe((x: any) => {
      if (x == true) {
        this.loadMenuData();
        this.loadUserLogo();

      }
    })
  }


  loadMenuData() {
    this.getMenuData().subscribe((x: any) => {
    });
  }
  loadUserLogo() {
    this.getLogo().subscribe((x: any) => { });
  }
  GetPermission(): void {
    if (sessionStorage.getItem('IsSetToken') == 'true') {
      this.loadUserFunctionsData();
    }
    this.isTokenSet.subscribe((x: any) => {
      if (x == true) {
        this.loadUserFunctionsData();
      }
    })
  }

  loadUserFunctionsData() {
    this.getUserFunctionsData().subscribe();
  }

  getUserFunctionsData(): Observable<any> {
    this.language = localStorage.getItem('i18Lang') || 'en-US';

    //if (this.data) {
    //  return of(this.data);
    //} else {
    let token = 'Bearer ' + sessionStorage.getItem('token');

    // Unsubscribe from previous subscription
    //this.unsubscribePermissions$.next();
    //this.unsubscribePermissions$.complete();
    //// Create a new subject for the current subscription
    //this.unsubscribePermissions$ = new Subject<void>();
    // Make the HTTP request and handle the response
    return this.http.get<any>('./api/Access/GetUserFunctions', {
      headers: new HttpHeaders({
        timeout: `${600000}`,
        authorization: token,
        'accept-language': this.language
      })
    }).pipe(
      //takeUntil(this.unsubscribePermissions$), // Unsubscribe when the component is destroyed
      tap(data => this.data = data),
      catchError(error => {
        // Handle errors if necessary
        console.error('Error fetching user functions data:', error);
        return of(null); // Return an observable with null value on error
      })
    );
    //}
  }

  private unsubscribe$ = new Subject<void>(); // Subject to manage unsubscription

  getMenuData(): Observable<any> {
    //if (this.menu) {
    //  // Return the existing menu wrapped in an Observable
    //  return of(this.menu);
    //} else {
    this.language = localStorage.getItem('i18Lang') || 'en-US';
    const token = 'Bearer ' + sessionStorage.getItem('token');
    //// Unsubscribe from previous subscription
    //this.unsubscribe$.next();
    //this.unsubscribe$.complete();
    //// Create a new subject for the current subscription
    //this.unsubscribe$ = new Subject<void>();
    // Make the HTTP request and handle the response
    return this.http.get<any>('./api/Menu/GetUserMenu', {
      headers: new HttpHeaders({
        timeout: `${600000}`,
        authorization: token,
        'accept-language': this.language
      })
    }).pipe(
      //takeUntil(this.unsubscribe$), // Unsubscribe when the component is destroyed
      tap(menu => {
        if (menu && menu.code === HttpStatusCode.NotFound) {
          // Handle NotFound case if needed
        } else if (menu.code === HttpStatusCode.Ok) {
          this.menu.next(menu);
          if (menu.data && menu.data.length > 0) {
            sessionStorage.setItem('ISOCurrencyCode', menu.data[0].isoCurrencyCode);
          }
        }
      }),
      catchError(error => {
        // Handle errors if necessary
        console.error('Error fetching menu:', error);
        return of(null); // Return an observable with null value on error
      })
    );
    //}
  }


  getLogo(): Observable<any> {
    this.language = localStorage.getItem('i18Lang') || 'en-US';
    const token = 'Bearer ' + sessionStorage.getItem('token');
    return this.http.get<any>('./api/Menu/GetUserInfo', {
      headers: new HttpHeaders({
        timeout: `${600000}`,
        authorization: token,
        'accept-language': this.language
      })
    }).pipe(
      tap(logoData => {

        if (logoData && logoData.code === HttpStatusCode.NotFound) {
          // Handle NotFound case if needed
        } else if (logoData.code === HttpStatusCode.Ok) {
          this.logo.next(logoData);
          if (logoData.data.logo != null) {
            if (logoData.data.logo.mineType == 'image/png') {
              let attachment = "data:image/png;base64," + logoData.data.logo.attachment;
              sessionStorage.setItem('loggedInUserLogo', attachment);

            }
            else if (logoData.data.logo.mineType == 'image/jpeg') {
              let attachment = "data:image/jpeg;base64," + logoData.data.logo.attachment;
              sessionStorage.setItem('loggedInUserLogo', attachment);
            }
            else {
              sessionStorage.setItem('loggedInUserLogo', '');

            }
          }
          else {
            sessionStorage.setItem('loggedInUserLogo', '');
          }
         

        }
      }),
      catchError(error => {
        // Handle errors if necessary
        console.error('Error fetching Logo:', error);
        return of(null); // Return an observable with null value on error
      })
    );
    //}
  }

  get UserPermission() {
    if (this.data) {
      return this.data.data;
    }

  }
}

